<template>
  <div>
    <div v-for="(item,index) in data.values" :key="index" class="">
      <div class="input-group mb-3">
        <input  type="text" class="form-control" v-model="item.key" placeholder="Variable name">
        <input type="text" class="form-control" v-model="item.value" placeholder="Variable value">
        <div class="input-group-append">
          <button @click="removeItem(index)" class="btn btn-sm btn-outline-danger">X</button>
        </div>
      </div>
    </div>
    <button @click="addItem" class="btn btn-outline-success">+</button>
  </div>
</template>


<script>
export default {
  name: 'StoreData',
  props:{
    data: Object,
  },
  methods:{
    addItem: function(){
      this.data.values.push({key:null,value:null});
    },
    removeItem: function(index){
      this.data.values.splice(index,1);
    }
  },
}
</script>
